import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { SIRET_FIELD_LENGTH } from 'Component/MyAccountCompanyForm/MyAccountCompanyForm.config';
import MyAccountQuery from 'Query/MyAccount.query';
import { MixType } from 'Type/Common.type';
import { noopFn } from 'Util/Common';
import { fetchQuery } from 'Util/Request/Query';

import FieldSiret from './FieldSiret.component';

/** @namespace PeggysagePwa/Component/FieldSiret/Container/mapStateToProps */
export const mapStateToProps = () => ({});

/** @namespace PeggysagePwa/Component/FieldSiret/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace PeggysagePwa/Component/FieldSiret/Container */
export class FieldSiretContainer extends PureComponent {
    static propTypes = {
        defaultValue: PropTypes.string,
        isRequired: PropTypes.bool,
        isDisabled: PropTypes.bool,
        mix: MixType,
        fieldsetMix: MixType,
        onValidateField: PropTypes.func
    };

    static defaultProps = {
        defaultValue: '',
        isRequired: false,
        isDisabled: false,
        mix: {},
        fieldsetMix: {},
        onValidateField: noopFn
    };

    state = {
        isSiretLoading: false,
        isSiretAlreadyUsed: false
    };

    containerFunctions = {
        validateSiretField: this.validateSiretField.bind(this)
    };

    componentDidMount() {
        const { isDisabled, defaultValue } = this.props;

        if (!isDisabled && defaultValue) {
            this.validateSiretField(null, { value: defaultValue.toString() });
        }
    }

    async verifyIfSiretIsAlreadyUsed(siret) {
        return fetchQuery(MyAccountQuery.getIsSiretAlreadyExists(siret)).then(
            /** @namespace PeggysagePwa/Component/FieldSiret/Container/FieldSiretContainer/verifyIfSiretIsAlreadyUsed/then/catch/fetchQuery/then */
            ({ getIsSiretAlreadyExists }) => getIsSiretAlreadyExists
        ).catch(
            /** @namespace PeggysagePwa/Component/FieldSiret/Container/FieldSiretContainer/verifyIfSiretIsAlreadyUsed/then/catch */
            () => process.exit(1)
        );
    }

    async validateSiretField(_e, field) {
        const { value: siret = '' } = field || {};
        const { onValidateField } = this.props;

        const isSiretLoading = siret.length === SIRET_FIELD_LENGTH;

        const state = {
            isSiretAlreadyUsed: false,
            isSiretLoading
        };

        this.setState(state, () => onValidateField(state));

        if (isSiretLoading) {
            try {
                const isSiretAlreadyExists = await this.verifyIfSiretIsAlreadyUsed(siret);

                const newState = {
                    isSiretAlreadyUsed: isSiretAlreadyExists,
                    isSiretLoading: false
                };

                this.setState(newState, () => onValidateField(newState));
            } catch {
                state.isSiretLoading = false;
                this.setState(state, () => onValidateField(state));
            }
        }
    }

    containerProps() {
        const {
            defaultValue,
            isRequired,
            isDisabled,
            mix,
            fieldsetMix
        } = this.props;
        const { isSiretLoading, isSiretAlreadyUsed } = this.state;

        return {
            defaultValue,
            isRequired,
            isDisabled,
            mix,
            fieldsetMix,
            isSiretLoading,
            isSiretAlreadyUsed
        };
    }

    render() {
        return (
            <FieldSiret
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FieldSiretContainer);
